import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import { DateTimeInput, TimestampInput } from "src/common/components/DateTime";
import { Field } from "src/common/components/Field";
import { isTodayOrBefore } from "src/common/utils/dates";

const messages = defineMessages({
	timestamp: {
		id: "form.timestamp",
		defaultMessage: "Esemény ideje (nem lehet jövőbeni)"
	},
	presence: {
		id: "form.timestamp.error.presence",
		defaultMessage: "Az esemény ideje kötelező."
	},
	max: {
		id: "form.timestamp.error.max",
		defaultMessage: "Az esemény ideje nem lehet jövőbeni."
	}
});

interface TimestampProps {
	showTimeInput?: boolean;
	disabled?: boolean;
	timestamp: string | undefined;
	onChangeTimestamp(timestamp: string | undefined): unknown;
}

export const Timestamp: React.FunctionComponent<TimestampProps> = ({
	showTimeInput,
	disabled,
	timestamp,
	onChangeTimestamp
}) => {
	const error = React.useMemo(() => {
		if (timestamp === undefined || timestamp === "") {
			return <FormattedMessage {...messages.presence} />;
		}
		if (!isTodayOrBefore(timestamp)) {
			return <FormattedMessage {...messages.max} />;
		}
	}, [timestamp]);
	return (
		<Field
			label={<FormattedMessage {...messages.timestamp} />}
			error={error}
			required={true}
		>
			{showTimeInput ? (
				<DateTimeInput
					disabled={disabled}
					value={timestamp}
					onChangeValue={onChangeTimestamp}
				/>
			) : (
				<TimestampInput
					disabled={disabled}
					value={timestamp}
					onChangeValue={onChangeTimestamp}
				/>
			)}
		</Field>
	);
};
